import { useEffect, useState } from 'react';

import { getRecentTagFixes, onRecentTagFixesChange } from './recentTagFixes';

const NONE = new Map<string, number>();

/**
 * When each resource group was recently fixed for `tagKey`, by normalised ARM id.
 * Re-reads whenever a fix is recorded, so views outside the dialog update as
 * soon as it applies tags.
 */
export const useRecentTagFixes = (
  tagKey: string | null | undefined,
): Map<string, number> => {
  const [fixes, setFixes] = useState(() =>
    tagKey ? getRecentTagFixes(tagKey) : NONE,
  );

  useEffect(() => {
    if (!tagKey) {
      setFixes(NONE);
      return undefined;
    }
    const refresh = () => setFixes(getRecentTagFixes(tagKey));
    refresh();
    return onRecentTagFixesChange(refresh);
  }, [tagKey]);

  return fixes;
};
